module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "miniprogindicator"
  }, [_c('div', {
    staticClass: "bg",
    style: (_vm.bgStyle())
  }), _c('div', {
    staticClass: "fg",
    style: (_vm.fgStyle())
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05b00241","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Minipctbar.vue
// module id = 578
// module chunks = 1